.datepicker {
  border:1px solid rgba(0, 0, 0, 0.10);
  border-radius: var(--border-radius);
}
@media (--lg) {
    .datepicker {
      display: flex;
      height: 100%;
      justify-content: center;
      align-items: center;
      border:0;
      background: var(--color-cool-gray);
      border-radius: var(--border-radius);
    }
}
